<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex justify-content-start">

        <h1 class="pl-3">Tabelas</h1>
        <span class="mt-2" style="padding: 6px 7px 10px 25px;">Empresa: </span>
        <select class="form-control mt-2" name="" id="" v-model="empresaSelected" @change="setEmpresa()">
          <option disabled value="">Selecione uma empresa</option>
          <option v-for="(empresa, index) in getEmpresas" :key="index" :value="empresa">{{ empresa.name }}
          </option>
        </select>
        <!-- <v-select :options="getEmpresas" v-model="empresaSelected" @input="setEmpresaLogin(empresaSelected)"
                            :placeholder="$t('Selecione a empresa')">
                        </v-select> -->
      </div>
      <div>
        <button @click="reloadPage" class="btn btn-light mr-3"><svg xmlns="http://www.w3.org/2000/svg" height="1em"
            viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
            <path
              d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z" />
          </svg></button>
        <button class="btn btn-outline-secondary mr-3" v-b-toggle.collapse-1>Script Livre</button>
      </div>

    </div>

    <b-collapse id="collapse-1" class="mt-2 m-3">
      <b-card>
        <p class="card-text">Escreva seu script SQL aqui:</p>
        <b-form-textarea id="textarea" v-model="textScript" placeholder="" rows="10" max-rows="6"></b-form-textarea>
        <button class="btn btn-outline-secondary mt-3 mr-3" @click="limparScript">Limpar</button>
        <button class="btn btn-outline-success mt-3" @click="submitScript">Executar</button>
      </b-card>
    </b-collapse>
    <div class="row pl-3">
      <div class="col-2" style="height: 653px; overflow: auto;">
        <input class="form-control" :placeholder="$t('Pesquisar')" v-model="searchTable" @input="pesquisarTabela" />

        <div v-for="(tabela, index) in tables" :key="index">
          <span class="btn p-2" @click="setTable(tabela.table_name)">{{ tabela.table_name }}</span>
          <hr class="m-0">
        </div>
      </div>

      <!-- :filters.sync="filters" -->

      <div class="col-10">
        <DataTable :value="data" ref="dt" showGridlines :paginator="false" class="p-datatable-customers p-datatable-sm"
          :rows="10" dataKey="id" :rowHover="true" :selection.sync="selectedCustomers" :loading="loading"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 25, 50]" responsiveLayout="scroll">

          <template #header>
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="m-0">Tabela: {{ nameTable }}</h5>
              <div>
                <button class="btn btn-outline-secondary mr-3" @click="exportCSV($event)">Exportar</button>

                <!-- <span class="p-input-icon-left">
                  <input class="form-control" v-model="filters['global'].value" :placeholder="$t('Pesquisa global')" />
                </span> -->
              </div>
            </div>
          </template>

          <template #empty>
            Sem nenhum resultado.
          </template>
          <template #loading>
            Carregando itens. Por favor aguarde.
          </template>

          <Column v-for="( campo, index ) in headers" :key="index" :field="campo" :header="campo" sortable
            :styles="{ 'min-width': '14rem' }">

            <template #body="{ data }">
              {{ data[campo] }}
            </template>

            <template #filter="{ filterModel }">
              <input type="text" v-model="filterModel.value" class="p-column-filter form-control"
                :placeholder="$t('Pesquisar')" />
            </template>

          </Column>
        </DataTable>
        <Paginator v-if="exibePaginacao" :rows="10" :totalRecords="totalRecords"
          template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Exibindo {first} até {last} de {totalRecords}" @page="onPage($event)"></Paginator>

      </div>
    </div>

  </div>
</template>

<script>

import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import Button from 'primevue/button';
import Paginator from 'primevue/paginator';


import { FilterMatchMode, FilterOperator } from 'primevue/api';


export default {
  components: {
    DataTable, // Use DataTable em vez de <DataTable>
    Column,
    Paginator
  },
  data() {
    return {
      // totalRecords: 30,
      currentPage: 1,
      headers: [],
      data: [],
      exportData: [],
      selectedCustomers: null,
      filters: {},
      loading: false,
      nameTable: null,
      // tables: [],
      textScript: '',
      searchTable: '',
      exibePaginacao: true
    };
  },
  computed: {
    getEmpresas() {
      return this.$store.getters['frotaItem/getBases']
    },
    totalRecords() {
      return this.$store.getters['frotaItem/getTotalPage']
    },
    tables() {
      return this.$store.getters['frotaItem/getTabelasFiltro']
    }
  },

  methods: {
    setEmpresa() {
      console.log(this.empresaSelected.name)

      const data = {
        nome_tabela: 'ordem_servico',
        current_page: 1,
        tp_base: 'I',
        db_name: this.empresaSelected.name
      }

        this.getTable(data)
    },

    onPage(event) {
      let currentPage = event.page + 1;

      const data = {
        nome_tabela: this.nameTable,
        current_page: currentPage,
        db_name: this.empresaSelected.name
      }

      this.getTable(data)
    },

    setTable(table) {
      this.searchTable = ''

      this.nameTable = table

      const data = {
        nome_tabela: table,
        db_name: this.empresaSelected.name
      }

      this.$store.dispatch('frotaItem/getTable', { data: data }).then(response => {
        this.data = response.data.dados.data
        this.headers = response.data.fields


        const dataField = {
          'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        }

        response.data.fields.forEach(chave => {
          dataField[chave] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        this.filters = dataField
      })
    },

    exportCSV() {
      // this.$refs.dt.exportCSV({
      //   data: this.exportData,
      //   columns: this.headers.map(field => ({ field, header: field }))
      // });

       // Verifique se há dados em allData
      const dataToExport = this.exportData.length ? this.exportData : this.data;
      const columnsToExport = this.headers.map(field => ({ field, header: field }));

      // Gera o conteúdo CSV
      const csvContent = [
        columnsToExport.map(col => col.header).join(","), // Cabeçalho CSV
        ...dataToExport.map(row => columnsToExport.map(col => row[col.field]).join(","))
      ].join("\n");

      // Cria um blob do CSV para download
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    limparScript() {
      this.$root.$emit('bv::toggle::collapse', 'collapse-1')

      this.textScript = ''
    },

    submitScript() {
      this.$root.$emit('bv::toggle::collapse', 'collapse-1')

      this.exibePaginacao = false

      const script = this.textScript.toUpperCase()

      const palavrasProibidas = ["DELETE", "DROP", "UPDATE"];

      const contemPalavraProibida = palavrasProibidas.some(palavra => script.includes(palavra));

      if (contemPalavraProibida) {
        this.$swal.fire({
          title: 'Ooops, olha lá!',
          text: 'Existe uma palavra proibida dentro do script!',
          icon: 'warning'
        })

        return false
      }

      const dataScript = {
        script: script,
        db_name: this.empresaSelected.name
      }

      this.$store.dispatch('frotaItem/executarScript', { data: dataScript }).then(response => {
        console.log(response.data)
        this.exportData = response.data.dados;      // Salva todos os dados para exportação
        this.data = this.exportData.slice(0, 10);  
        this.headers = response.data.fields
        this.nameTable = 'Select Dinâmico'
      })

    },

    pesquisarTabela() {

      const tabela = this.searchTable

      this.$store.dispatch('frotaItem/pesquisarTabela', { tabela: tabela })
    },

    reloadPage() {
      window.location.reload()
    },

    getTable(data) {
      this.$store.dispatch('frotaItem/getTable', { data: data }).then(response => {
        this.data = response.data.dados.data
        this.headers = response.data.fields
        // this.tables = response.data.tabelas

        const dataField = {
          'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        }

        response.data.fields.forEach(chave => {
          dataField[chave] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        this.filters = dataField
      })
    },

    selectBases(data) {
      this.$store.dispatch('frotaItem/selectBases', { data: data }).then((response) => {
        this.arrayBases = response
      })
    },
  },

  created() {
    const data = {
      nome_tabela: 'ordem_servico',
      current_page: 1,
      tp_base: 'I',
      db_name: 'ginfo_log20'
    }

    this.selectBases(data)
    this.nameTable = data.nome_tabela

    this.getTable(data)

  }
};
</script>